import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.css']
})
export class PrivacyComponent implements OnInit {
  modalReference: any
  @ViewChild("content") modalContent: TemplateRef<any>;

  constructor(private modalService: NgbModal) { }

  ngOnInit() {
  }

  open() {
    this.modalReference = this.modalService.open(this.modalContent, { ariaLabelledBy: 'modal-basic-title', size: 'xl', backdrop: 'static' });
  }

  close() {
    this.modalReference.close();
  }
}
